"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addPictureToGallery } from "@/lib/actions/gallery/post/addPictureToGallery";

const serverAddPictureToGallery = async ({
  name,
  imageUrl,
}: {
  name: string;
  imageUrl: string;
}) => {
  const response = await addPictureToGallery({ name, imageUrl });
  return response;
};

export const useAddPictureToGallery = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: serverAddPictureToGallery,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["gallery"] });
    },
  });
};
